
import throttle from 'lodash/throttle';


function updateInnerHeight(){

	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	let vh = window.innerHeight * 0.01;

	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty('--vh', `${vh}px`);

}

const throttledUpdate = throttle(updateInnerHeight, 1000)

window.addEventListener('resize', throttledUpdate);


// Fire it once to begin with
updateInnerHeight();